import { SelectionModel } from '@angular/cdk/collections';
import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ContextChange, WidgetStyle } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { TranslationService } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { EditorBlacklistDetails } from '../blacklist-administration.model';
import { BlacklistAdministrationService } from '../blacklist-administration.service';
import { AbstractWidgetComponent } from '@sdbn/appclient';

@Component({
  selector: 'app-blacklist-administration',
  templateUrl: './blacklist-administration.component.html',
  styleUrls: ['./blacklist-administration.component.scss']
})
export class BlacklistAdministrationComponent extends AbstractWidgetComponent {

  responseMessages: ResponseMessage[];

  loading = false;
  dirty = false;
  valid = false;

  // @ViewChild(MatSort) sort: MatSort;
  sortDirection = 'asc';
  sortColumn = 'company';
  columnsToDisplay = [
    'company', 'name', 'firstname', 'numberPlate', 'note', 'btn'
  ];

  blacklistDetails = new Array<EditorBlacklistDetails>();
  dataSource = new MatTableDataSource(new Array<EditorBlacklistDetails>());
  selection = new SelectionModel<EditorBlacklistDetails>();

  constructor(
    public translationService: TranslationService,
    private dialog: MatDialog,
    private blacklistAdministrationService: BlacklistAdministrationService
  ) {
    super();
    this.loadBlacklist();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  public toggleSelection(details: EditorBlacklistDetails) {

    this.blacklistDetails.forEach(b => b.selected = false);

    if (details !== this.selection.selected[0]) {
      details.selected = true;
      this.selection.toggle(details);
    }
  }

  public blacklistDetailsChanged(details: EditorBlacklistDetails) {
    details.dirty = true;
    this.updateViewModel();
  }

  public save() {
    this.loading = true;
    this.responseMessages = [];

    const changedDetails = this.blacklistDetails.filter(b => b.dirty);
    this.blacklistAdministrationService.saveBlacklist(changedDetails).subscribe(
      result => {
        if (result.status === ResponseStatus.FAILED) {
          this.responseMessages = result.responseMessages;
        } else {
          this.loadBlacklist();
        }
        this.loading = false;
      }, error => {
        this.loading = false;
      }
    );
  }

  public addDetails() {
    const newEntry = new EditorBlacklistDetails();
    newEntry.dirty = true;
    this.blacklistDetails.push(newEntry);
    this.dataSource.data = this.blacklistDetails.filter(d => !d.deleted);
    this.toggleSelection(newEntry);
    this.updateViewModel();
  }

  public cancel() {
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.blacklist-administration.cancel.confirm-dialog.title',
      messageKey: 'tmc-yard.widgets.blacklist-administration.cancel.confirm-dialog.message',
      confirm: () => {
        this.selection.clear();
        this.loadBlacklist();
      }
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  public delete(details: EditorBlacklistDetails) {

    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.blacklist-administration.delete.confirm-dialog.title',
      messageKey: 'tmc-yard.widgets.blacklist-administration.delete.confirm-dialog.message',
      confirm: () => {
        details.dirty = true;
        if (details.id != null) {
          details.deleted = true;
        } else {
          this.blacklistDetails.splice(this.blacklistDetails.indexOf(details), 1);
        }
        this.updateViewModel();
        this.dataSource.data = this.blacklistDetails.filter(d => !d.deleted);
      }
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  private loadBlacklist() {
    this.loading = true;
    this.responseMessages = [];

    this.blacklistAdministrationService.loadBlacklist().subscribe(
      result => {
        this.blacklistDetails = new Array<EditorBlacklistDetails>();
        result.forEach(r => {
          this.blacklistDetails.push(new EditorBlacklistDetails(r));
        });
        this.dataSource.data = this.blacklistDetails;
        this.updateViewModel();
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

  private updateViewModel() {
    let valid = true;
    let dirty = false;
    this.blacklistDetails.forEach(
      b => {
        b.valid = (b.company != null && b.company.length > 0) ||
          (b.name != null && b.name.length > 0) ||
          (b.firstname != null && b.firstname.length > 0) ||
          (b.numberPlate != null && b.numberPlate.length > 0);

        if (!b.valid) {
          valid = false;
        }
        if (b.dirty) {
          dirty = true;
        }
      }
    );
    this.valid = valid;
    this.dirty = dirty;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
